import React from 'react'
import Input from '../inputs/Input'
import FormGrid from '../layouts/FormGrid'
import PageTitle from '../layouts/PageTitle'
import useSteps from '../../hooks/useSteps'
import NextStepButton from '../utils/NextStepButton'
import InputWrap from "../inputs/InputWrap";
import PrevStepButton from "../utils/PrevStepButton";

export default function ContactInformation () {
  const { nextStep } = useSteps()

  return (
    <>
      <PageTitle step={1}/>
      <FormGrid>
        <Input name={'name'} subobj={'contact'} label={'Navn på bestiller'} placeholder={'Indtast fulde navn'} required={true} autocomplete={'name'} />
        <Input name={'company_name'} subobj={'contact'} label={'Firmanavn'} placeholder={'Indtast firmanavn'} required={true} size={'half'} autocomplete={'organization'} />
        <Input name={'vat'} subobj={'contact'} label={'CVR-nr'} placeholder={'Indtast CVR-nr'} required={true} size={'half'} />
        <Input name={'email'} subobj={'contact'} label={'Mail'} placeholder={'Indtast mail'} required={true} size={'half'} type={'email'} autocomplete={'email'} />
        <Input name={'phone'} subobj={'contact'} label={'Telefonnr'} placeholder={'Indtast nr'} required={true} size={'half'} type={'tel'} autocomplete={'tel'} />
        <InputWrap>
          <div className={'ad-next-step'}>
            <PrevStepButton label={'Tilbage'} style={'outline-dark arrow-flipped'}/>
            <NextStepButton label={'Gå til betaling'} style={'secondary'}/>
          </div>
        </InputWrap>
      </FormGrid>
    </>
  )
}
